import { SET_CHAT_REQUEST, SET_CHAT_REQUEST_USERS, SET_STORY_DISCUS, SET_CHAT_MEETING_USERS, SET_CHAT_DATE_UTC, SET_CHAT_SCHEDULE_USERS, SET_MESSAGE_USERS, SET_OPEN_CHAT, SET_NO_READR_MESSAGES, SET_MEET_REVIEW } from './constants'

export const setChatRequestAction = payload => ({ type: SET_CHAT_REQUEST, payload })
export const setChatRequestUsersAction = payload => ({ type: SET_CHAT_REQUEST_USERS, payload })
export const setChatMeetingAction = payload => ({ type: SET_CHAT_MEETING_USERS, payload })
export const setChatScheduleAction = payload => ({ type: SET_CHAT_SCHEDULE_USERS, payload })
export const setStoryDiscusActions = payload => ({ type: SET_STORY_DISCUS, payload })
export const setUtcActions = payload => ({ type: SET_CHAT_DATE_UTC, payload })
export const setMessageUserActions = payload => ({ type: SET_MESSAGE_USERS, payload })
export const setOpetChatActions = payload => ({ type: SET_OPEN_CHAT, payload })
export const setNoReadMessagesActions = payload => ({ type: SET_NO_READR_MESSAGES, payload })
export const setMeetReviewActions = payload => ({ type: SET_MEET_REVIEW, payload })

export const setMeetReview = data => dispatch => dispatch(setMeetReviewActions(data))
export const setNoReadMessages = data => dispatch => dispatch(setNoReadMessagesActions(data))
export const setOpenChat = data => dispatch => dispatch(setOpetChatActions(data))
export const setMessageUser = data => dispatch => dispatch(setMessageUserActions(data))
export const setChatRequest = data => dispatch => dispatch(setChatRequestAction(data))
export const setChatRequestUsers = data => dispatch => dispatch(setChatRequestUsersAction(data))
export const setChatMeeting = data => dispatch => dispatch(setChatMeetingAction(data))
export const setChatSchedule = data => dispatch => dispatch(setChatScheduleAction(data))

export const setUtc = data => dispatch => dispatch(setUtcActions(data))

export const setStoryDiscus = data => dispatch => dispatch(setStoryDiscusActions(data))
